import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

export function Card({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-lg bg-white border border-zinc-200 shadow-sm',
        // Dark: card sits one step above the page (zinc-900 vs zinc-950),
        // with a clearly-visible zinc-600 border (vs near-black surface) so
        // the card outline is unambiguous in dark mode.
        'dark:bg-zinc-900 dark:border-zinc-600',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-4', className)}>
      <div className="min-w-0">
        <div className="text-base font-semibold text-zinc-950 dark:text-zinc-50">{title}</div>
        {subtitle && (
          <div className="mt-0.5 text-sm text-zinc-600 dark:text-zinc-300">{subtitle}</div>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
